<script setup>
const props = defineProps({
    item: {
        type: Object,
        default: {}
    }
})

const fullUrl = (url) => {
    return url && url[0] === '/' ? `${window.location.origin}${url}` : url;
}
</script>

<template>
    <div class="card-horizontal flex grow gap-2 column-tablet bordered-paragraph padding-v-2">
        <div class="flex column gap-1">
            <h6 class="grow text-color-strong">
                {{ item.title }}
            </h6>
            <p class="grow text-color-strong" v-html="item.description"></p>
            <div class="text-xs text-color-weak">{{fullUrl(item.url)}}</div>
            <a
                class="btn-link-arrow margin-t-3"
                :href="item.url"
                target="_blank"
            >
                <span>Read more</span>
            </a>
        </div>
    </div>
</template>

<style scoped>

</style>
